import { render, staticRenderFns } from "./FooterBottom.vue?vue&type=template&id=7d710625&scoped=true&"
import script from "./FooterBottom.vue?vue&type=script&lang=js&"
export * from "./FooterBottom.vue?vue&type=script&lang=js&"
import style0 from "./FooterBottom.vue?vue&type=style&index=0&id=7d710625&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d710625",
  null
  
)

export default component.exports